<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>{{
            editedIndex == -1
              ? "Create Minimum Price Food"
              : "Edit Minimum Price Food"
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('onClosed')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="form">
            <div class="heading_5__style">District category</div>
            <div>
              <v-radio-group
                row
                hide-details
                v-model="form.sod_is_all_district"
                @change="form.sod_store_id = []"
              >
                <v-radio
                  color="primary"
                  label="All district"
                  :value="true"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Some district"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </div>
            <div v-if="form.sod_is_all_district == false">
              <v-select
                multiple
                hide-details
                :items="districtList"
                label="Select district"
                :rules="[(v) => v.length > 0 || 'required']"
                v-model="form.sod_district_id"
                item-text="district_name_th"
                item-value="district_id"
                :loading="isLoadingDistrict"
                @change="form.sod_store_id = []"
              ></v-select>
            </div>
            <div class="mt-4 heading_5__style">Select store</div>
            <div>
              <v-radio-group row hide-details v-model="form.sod_is_all_store">
                <v-radio
                  color="primary"
                  label="All store"
                  :value="true"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Some store"
                  :value="false"
                ></v-radio>
              </v-radio-group>
            </div>
            <div v-if="form.sod_is_all_store == false">
              <v-autocomplete
                multiple
                hide-details
                :items="filterStoreList"
                label="Select store"
                :rules="[(v) => v.length > 0 || 'required']"
                v-model="form.sod_store_id"
                item-text="store_name_th"
                item-value="store_id"
                :loading="isLoadingStore"
              ></v-autocomplete>
            </div>
            <div class="mt-4 heading_5__style">Set minimum price</div>
            <div class="mt-3">
              <v-text-field
                v-model="form.sod_minimum_price"
                outline
                placeholder="Ex. 80"
                type="number"
                :rules="[(v) => !!v || 'required', rules.onlyNumber]"
                hide-details
                suffix="THB"
                single-line
              ></v-text-field>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            outline
            style="border-radius: 7px"
            color="#EC5F59"
            @click="resetForm()"
            :disabled="isSubmit"
            >Reset</v-btn
          >
          <v-btn
            outline
            style="border-radius: 7px"
            color="#67AD5B"
            @click="submit()"
            :loading="isSubmit"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    dialog: {
      type: Boolean,
      default() {
        return false;
      },
    },
    editedIndex: {
      default() {
        return -1;
      },
    },
    selectedItem: {
      default() {
        return {};
      },
    },
  },
  data: () => ({
    form: {
      sod_is_all_district: true,
      sod_is_all_store: true,
      sod_district_id: [],
      sod_store_id: [],
      sod_status: 0,
      sod_minimum_price: null,
    },
    districtList: [],
    storeList: [],
    isLoadingDistrict: false,
    isLoadingStore: false,
    valid: true,
    isSubmit: false,
    rules: {
      onlyNumber: (value) => /^[^\W_]+$/.test(value) || "invalid format",
    },
  }),
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.isSubmit = false;
        if (this.storeList.length == 0) this.getStoreList();
        if (this.districtList.length == 0) this.getDistrictList();
        if (this.editedIndex == -1) {
          this.resetForm();
        } else {
          let cloneObj = JSON.parse(JSON.stringify(this.selectedItem));
          if (cloneObj.sod_district_id == "All District") {
            cloneObj.sod_is_all_district = true;
            cloneObj.sod_district_id = [];
          } else {
            cloneObj.sod_is_all_district = false;
            cloneObj.sod_district_id = cloneObj.sod_district_id.map(
              (val) => val.district_id
            );
          }
          if (cloneObj.sod_store_id == "All Store") {
            cloneObj.sod_is_all_store = true;
            cloneObj.sod_store_id = [];
          } else {
            cloneObj.sod_is_all_store = false;
            cloneObj.sod_store_id = cloneObj.sod_store_id.map(
              (val) => val.store_id
            );
          }
          this.form = cloneObj;
        }
      }
    },
  },

  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      provinceNameEn: (state) => state.backOffice.province,
    }),
    filterStoreList() {
      if (this.form.sod_district_id.length == 0) {
        return this.storeList;
      }
      return this.storeList.filter((val) =>
        this.form.sod_district_id.includes(val.store_district_id)
      );
    },
  },
  methods: {
    ...mapActions({
      fetchDistrictList: "fetchProvinceBack/getDistrictCore",
    }),
    resetForm() {
      this.form = {
        sod_is_all_store: true,
        sod_is_all_district: true,
        sod_district_id: [],
        sod_store_id: [],
        sod_status: 1,
        sod_minimum_price: null,
      };
      this.$refs.form.resetValidation();
    },
    async getDistrictList() {
      let province = this.provinceNameEn;
      this.isLoadingDistrict = true;
      let provinceItem = this.provinceData.find(
        (val) =>
          val.province_name_en.toLowerCase().replace(/ /g, "") == province
      );
      this.districtList = await this.fetchDistrictList(
        provinceItem.province_id
      );
      this.isLoadingDistrict = false;
    },
    async getStoreList() {
      this.isLoadingStore = true;
      let responseList = await this.$store.dispatch(
        "fetchStoreBack/getStoreList"
      );
      this.storeList = responseList;
      this.isLoadingStore = false;
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.isSubmit = true;
      this.$emit("onSaved", {
        done() {
          this.isSubmit = false;
        },
        form: this.form,
      });
    },
  },
};
</script>

<style scoped>
.heading_5__style {
  font-size: 20px;
  font-weight: bold;
}
</style>
